import { Grid, Skeleton } from '@mui/material'
import React from 'react'

function FiltersSkeleton() {
    return (
        <Grid container spacing={4}>
            {[...Array(9)].map(e => (
                <Grid item md={3} xs={12} sm={6} key={e}>
                    <Skeleton sx={{ borderRadius: 1 }} variant='rectangular' height={50} width={'100%'}></Skeleton>
                </Grid>
            ))}

        </Grid>
    )
}

export default FiltersSkeleton